import { WINDOW } from '@/window';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScreenSizeService {
  screenWidth: number;
  screenHeight: number;
  screenSize: string;

  constructor(
    @Inject(WINDOW) private window: Window
  ) {
    this.screenHeight = this.window.innerWidth;
    this.screenWidth = this.window.innerHeight;
    this.screenSize = '';
    this.setScreenSizeOnResize();
  }

  private setScreenSizeOnResize(): void {
    this.window.addEventListener("resize", () => {
      this.screenHeight = this.window.innerWidth;
      this.screenWidth = this.window.innerHeight;
    });
  }

  getScreenSize(): string {
    return `${this.screenHeight}X${this.screenWidth}`;
  }
}
